import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getAuth } from '../getAuth';
export const getUser = createSelector(getAuth, get('user'));